import ChartDrawComponent from './components/ChartDraw.vue';

const ChartDraw = {
    install(Vue) {
        Vue.component('chart-draw', ChartDrawComponent);
    },
};
export default ChartDraw;

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(ChartDraw);
}